import { FrontendEventCategories, FrontendEventTypes, FrontendRequirements, Sensors } from '../types';

export function createSensorTranslations(translateFn: Function): { [sensor in Sensors]: string } {
  return {
    [Sensors.ENDPOINT]: translateFn('Endpoint'),
    [Sensors.OFFICE365]: translateFn('Office 365'),
  };
}

export function createCategoryTranslations(translateFn: Function): { [category in FrontendEventCategories]: string } {
  return {
    [FrontendEventCategories.FILE]: translateFn('File'),
    [FrontendEventCategories.NETWORK]: translateFn('Network'),
    [FrontendEventCategories.PROCESS]: translateFn('Process'),
    [FrontendEventCategories.REGISTRY]: translateFn('Registry'),
    [FrontendEventCategories.USER]: translateFn('User'),
    [FrontendEventCategories.SERVICE]: translateFn('Service'),
    [FrontendEventCategories.SCHEDULED_TASK]: translateFn('Scheduled task'),
    [FrontendEventCategories.O365]: translateFn('Office 365'),
    [FrontendEventCategories.SERVICE]: translateFn('Service'),
  };
}

export function createEventTypeTranslations(translateFn: Function): { [eventType in FrontendEventTypes]: string } {
  return {
    [FrontendEventTypes.INJECTION]: translateFn('Injection'),
    [FrontendEventTypes.CREATE_KEY]: translateFn('Create key'),
    [FrontendEventTypes.DELETE_KEY]: translateFn('Delete key'),
    [FrontendEventTypes.DELETE_VALUE]: translateFn('Delete value'),
    [FrontendEventTypes.MODIFY_VALUE]: translateFn('Modify value'),
    [FrontendEventTypes.CONNECTION]: translateFn('Connection'),
    [FrontendEventTypes.CREATE]: translateFn('Create'),
    [FrontendEventTypes.DELETE]: translateFn('Delete'),
    [FrontendEventTypes.LOG_ON]: translateFn('Logon'),
    [FrontendEventTypes.LOG_OUT]: translateFn('Logout'),
    [FrontendEventTypes.LOG_ON_FAILED]: translateFn('Logon failed'),
    [FrontendEventTypes.MODIFY]: translateFn('Modify'),
    [FrontendEventTypes.MOVE]: translateFn('Move'),
    [FrontendEventTypes.READ]: translateFn('Read'),
    [FrontendEventTypes.TERMINATE]: translateFn('Terminate'),
    [FrontendEventTypes.ADDED]: translateFn('Added'),
    [FrontendEventTypes.USER_SPECIFIC]: translateFn('User specific'),
    [FrontendEventTypes.SECURITY_CENTER]: translateFn('Security center'),
    [FrontendEventTypes.SETTINGS_CHANGED]: translateFn('Settings changed'),
    [FrontendEventTypes.CHANGE_STATUS]: translateFn('Change status'),
    [FrontendEventTypes.O365_MAIL]: translateFn('O365 Mail'),
    [FrontendEventTypes.AMSI_BUFFER]: translateFn('AMSI buffer'),
  };
}

export function createRequirementTranslations(translateFn: Function): { [requirement: string]: string } {
  return {
    [FrontendRequirements.DEFAULT]: translateFn(
      'Licenses: a product license that includes EDR or XDR, and a GravityZone EDR Data Retention Add-on.'
    ),
    [FrontendRequirements.O365_MAIL]: translateFn(
      'Integration must be active in Sensors Management. Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on, and the Bitdefender XDR Sensor - Productivity license.'
    ),
    [FrontendRequirements.SERVICE_ADDED]: translateFn(
      'Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on. Local security policy:  Security Settings\\Advanced Audit Policy Configuration\\System Audit Policies - Local Group Policy Object\\System\\Audit Security System Extension.'
    ),
    [FrontendRequirements.USER_LOGON_FAILED]: translateFn(
      'Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on. Local security policy:  Security Settings\\Advanced Audit Policy Configuration\\System Audit Policies - Local Group Policy Object\\Logon/Logoff\\Audit Logon.'
    ),
    [FrontendRequirements.USER_ACCOUNT_SETTINGS_CHANGE]: translateFn(
      'Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on. Local security policy:  Security Settings\\Advanced Audit Policy Configuration\\System Audit Policies - Local Group Policy Object\\Account Management\\Audit User Account Management.'
    ),
    [FrontendRequirements.SCHEDULE_TASk_CREATE]: translateFn(
      'Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on. Local security policy:  Security Settings\\Advanced Audit Policy Configuration\\System Audit Policies - Local Group Policy Object\\Object Access\\Audit Other Object Access Events.'
    ),
    [FrontendRequirements.SCHEDULE_TASK_DELETE]: translateFn(
      'Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on. Local security policy: Security Settings\\Advanced Audit Policy Configuration\\System Audit Policies - Local Group Policy Object\\Object Access\\Audit Other Object Access Events.'
    ),
    [FrontendRequirements.SCHEDULE_TASK_MODIFY]: translateFn(
      'Licenses: a product license that includes EDR or XDR, a GravityZone EDR Data Retention Add-on. Local security policy: Security Settings\\Advanced Audit Policy Configuration\\System Audit Policies - Local Group Policy Object\\Object Access\\Audit Other Object Access Events.'
    ),
    [FrontendRequirements.AMSI_BUFFER]: translateFn(
      'The Fileless Attack Protection > Antimalware Scan Interface Security Provider option must be selected in the applied policy. Licenses: a product license that includes EDR or XDR, and a GravityZone EDR Data Retention Add-on.'
    ),
  };
}

export function convertTranslationToGridEnumValues(translation: {
  [value: string]: string;
}): Array<{ value: string; label: string }> {
  return Object.entries(translation).map(([key, val]) => {
    return {
      value: key,
      label: val,
    };
  });
}
